import { Icp } from '@/types/icp';
import fetchWithAuth from './base';
import { ListResponse } from '@/types/common';

export const getIcps = async ({
  clientId,
  startingAfter,
  endingBefore,
  limit,
  search,
}: {
  clientId: string;
  startingAfter?: string;
  endingBefore?: string;
  limit?: number;
  search?: string;
}): Promise<ListResponse<Icp>> => {
  const params = new URLSearchParams();
  if (startingAfter) {
    params.append('starting_after', startingAfter);
  }
  if (endingBefore) {
    params.append('ending_before', endingBefore);
  }
  if (limit) {
    params.append('limit', limit.toString());
  }
  if (search) {
    params.append('search', search);
  }

  const response = await fetchWithAuth(`/api/client/${clientId}/icp?${params.toString()}`, {
    method: 'GET',
  });
  return response.json();
};

export const getIcp = async (clientId: string, id: string): Promise<Icp> => {
  const response = await fetchWithAuth(`/api/client/${clientId}/icp/${id}`, {
    method: 'GET',
  });
  return response.json();
};
export const createIcp = async (clientId: string, data: Partial<Icp>) => {
  const response = await fetchWithAuth(`/api/client/${clientId}/icp`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const updateIcp = async (clientId: string, id: string, data: Partial<Icp>) => {
  const response = await fetchWithAuth(`/api/client/${clientId}/icp/${id}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });
  return response.json();
};

export const deleteIcp = async (clientId: string, id: string): Promise<void> => {
  await fetchWithAuth(`/api/client/${clientId}/icp/${id}`, {
    method: 'DELETE',
  });
};
